const theme = {
    colors: {
        primary: "#2f9df8",
        black: "#212529",
        gray: "#4b4b4b",
        darkGray: "rgb(75, 75, 75)",
        lightGray: "#bcbcbc",
        secondary: "rgb(1, 85, 154)",
        green: "#9fee92",
        red: "#fc2c03",
    },
    typography: {
        fontWeight: {
            semibold: 600,
            bold: 700,
            thin: 400,
            normal: 500,
        },
    },
    spacing: "1rem",
};

export default theme;
